require('./remindersListService');

angular.module('app.myHockeyTv.manageReminders.manageRemindersService', [
  'app.myHockeyTv.manageReminders.remindersListService'
])
  .factory('app.myHockeyTv.manageReminders.manageRemindersService', [
    '$http',
    'app.myHockeyTv.manageReminders.remindersListService',
    function ($http, remindersList) {
      "use strict";

      return {
        "new": function (defaults) {
          if (!defaults) {
            defaults = {};
          }
          return {
            icalid_fk: defaults.icalid_fk || null,
            iremindertypeid_fk: defaults.iremindertypeid_fk || null,
            iteamid_fk: defaults.iteamid_fk || null,
            ireminderfrequencyid_fk: defaults.ireminderfrequencyid_fk || null,
            ireminderhours: defaults.ireminderhours || null,
            strremindername: defaults.strremindername || null
          };
        },
        save: function (reminder) {
          let reminderId = reminder ? reminder.ireminderid : null;
          reminder = {
            strremindername: reminder.strremindername,
            icalid_fk: reminder.icalid_fk,
            iremindertypeid_fk: reminder.iremindertypeid_fk,
            ireminderfrequencyid_fk: reminder.ireminderfrequencyid_fk,
            iteamid_fk: reminder.iteamid_fk,
            ireminderhours: reminder.ireminderhours
          };

          if (reminderId) {
            return $http.put(window.location.api('reminders/' + reminderId), reminder)
              .then(function (response) {
                remindersList.retrieve();
                return response;
              })
          }
          else {
            return $http.post(window.location.api('reminders'), reminder)
              .then(function (response) {
                remindersList.retrieve();
                return response;
              });
          }
        },
        delete: function (reminder_id) {
          return $http["delete"](window.location.api('reminders/' + reminder_id))
            .then(function (response) {
              remindersList.retrieve();
              return response;
            });
        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/manageReminders/manageReminderService.js